import { GooglePlacesAddressModel, GooglePlacesDetails, GooglePlacesAddressFormValue } from './google-places.model';

interface AutocompleteSuggestion {
  prediction?: {
    text?: {
      text?: string;
    };
  };
}

export class GooglePlacesFormHelper {
  static readonly DEFAULT_DEBOUNCE_TIME = 300;
  static readonly STREET_AUTOCOMPLETE_REQUEST = {
    includedRegionCodes: ['US'],
  };
  static readonly CITY_AUTOCOMPLETE_REQUEST = {
    includedPrimaryTypes: ['locality', 'postal_town'],
    includedRegionCodes: ['US'],
  };

  static displayWithFn(value: unknown): string {
    if (GooglePlacesFormHelper.isSuggestion(value)) {
      return value.prediction?.text?.text ?? '';
    }

    return typeof value === 'string' ? value : '';
  }

  private static isSuggestion(value: unknown): value is AutocompleteSuggestion {
    return value !== null && typeof value === 'object' && 'prediction' in value;
  }

  private static parseStreetLine1(address: GooglePlacesAddressModel): string {
    if (!address) {
      return '';
    }

    return address.streetNumber ? `${address.streetNumber} ${address.street}`.trim() : address.street || '';
  }

  static mapToFullAddress(placeDetails: GooglePlacesDetails): GooglePlacesAddressFormValue {
    const address = placeDetails?.address;

    if (!address) {
      return {};
    }

    const line1 = GooglePlacesFormHelper.parseStreetLine1(address);

    return {
      line1,
      line2: address.addressLine2 || '',
      city: address.city || '',
      state: address.regionCode || '',
      zip: address.postalCode || '',
    };
  }

  static mapToCityAddress(placeDetails: GooglePlacesDetails): GooglePlacesAddressFormValue {
    const address = placeDetails?.address;

    if (!address) {
      return {};
    }

    return {
      city: address.city || '',
      state: address.regionCode || '',
    };
  }
}
